module.exports = "<div ui-view=main id=mainview></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customerShifts/shift.html
// module id = 422
// module chunks = 0